import { Component, Inject, OnInit } from '@angular/core'; 
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-affiliate-app-suggestion-dialog',
  templateUrl: './affiliate-app-suggestion-dialog.component.html',
  styleUrls: ['./affiliate-app-suggestion-dialog.component.scss']
})
export class AffiliateAppSuggestionDialogComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public _data: any,
    public _matDialogRef: MatDialogRef<AffiliateAppSuggestionDialogComponent>,
  ) { 

  }

  ngOnInit(): void {
  }

  closeDialog(): void {
    this._matDialogRef.close();
  }

  onIOS(){
    window.open('https://apps.apple.com/us/app/phlenu-delivery/id1483890270', '_black')
  }
  onAndroid(){
    window.open('https://play.google.com/store/apps/details?id=com.phlenu.delivery&hl=en', '_black')
  }
}
